module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/before-using-vux-57.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/about/before-using-vux.md
// module id = 630
// module chunks = 466